import { CircularProgress, Grid } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { getCollectionCategoryDesignData } from "../../Category/API/api";
import Product from "features/clients/Purchase/Category/ProductPage/Product";
import { transformDataForTrayModal } from "utils/transformdata";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import GoToTop from "components/ui/GoToTop";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import { ProductCard } from "components/ui";
import { useGetPurchaseCollectionDesign } from "../API/api";
import { useParams } from "react-router-dom";
import { useInView } from "react-intersection-observer";

function CollectionDesignPurchasePage({ collection, category }) {
  const { ref, inView } = useInView({ threshold: 0.8 });
  const [loading, setLoding] = useState(true);
  const [collectionProductData, setCollectionProductData] = useState([]);
  const { clientId } = useParams();

  // const { designs: collectionProductData, total } = getCollectionCategoryDesignData();
  const { setSortOptions } = useContext(SortContext);

  const { setFilterChangeCount, setDisplayCount, setFilterChangeDesignCount, setSearchResultCount, setSearchSuffix, dynamicfilterCount, filterChangeCount, filterChangeDesignCount } =
    useGlobalContext();

  //API
  let payload = {
    clientCode: clientId,
    collectionName: collection,
    categoryName: category,
    limit: 10,
    page: 1,
  };
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, error } = useGetPurchaseCollectionDesign(payload);

  useEffect(() => {
    if (data) {
      setCollectionProductData(data?.pages?.flatMap((page) => page.data) || []);
    }
  }, [data]);

  useEffect(() => {
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.pages[0]?.totalDesigns || 0);
      setSearchResultCount(0);
    } else {
      setSearchResultCount(0);
      setFilterChangeCount(filterChangeCount);
    }

    setDisplayCount(true);
    setSearchSuffix("");

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchSuffix("");
    };
  }, [collectionProductData]);

  useEffect(() => {
    setSortOptions(["d", "e", "f"]);
    return () => {
      setSortOptions([]);
    };
  }, []);

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage]);

  if (isLoading) {
    return <ProductSkeleton count={20} />;
  }

  if (error) {
    return <p>Error</p>;
  }

  return (
    <>
      <Grid
        id="collection-scroll"
        container
        direction="row"
        justifyContent="flex-start"
        sx={{
          flex: "1 1 1",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "30px",
          rowGap: "32px",
          maxHeight: "calc(100vh - 145px)",
          overflow: "auto",
          scrollbarWidth: "none",
        }}
        className="Grid-padding"
        rowGap={"16px"}
      >
        {collectionProductData?.length > 0 &&
          collectionProductData?.map((product, ind) => {
            return (
              <Grid item className="product" key={product._id}>
                <ProductCard data={transformDataForTrayModal(product)} style={{ maxWidth: "474px", minWidth: "474px" }} allData={collectionProductData} />
              </Grid>
            );
          })}

        {hasNextPage && <div ref={ref} style={{ height: 1, width: "100%" }} />}
         {isFetchingNextPage && <ProductSkeleton count={20} />}

      </Grid>

      <GoToTop />

     
      {collectionProductData?.length === 0 && (
        <div
          style={{
            display: "flex",
            textAlign: "center",
            margin: "auto",
            padding: "auto",
            justifyContent: "center",
            alignItems: "center",
            height: "78vh",
          }}
        >
          <Background />
        </div>
      )}
    </>
  );
}

export default CollectionDesignPurchasePage;
